import api from './client'

export const preseaApi = {
  test: () => api.get('/presea/test'),
  cola: (params = {}) => api.get('/presea/cola', { params }),
  colaItem: (id) => api.get(`/presea/cola/${id}`),
  colaReintentar: (id) => api.post(`/presea/cola/${id}/reintentar`),
  procesarCola: () => api.post('/presea/procesar-cola'),
  colaLimpiar: () => api.post('/presea/cola/limpiar'),
  sincronizaciones: () => api.get('/presea/sincronizaciones'),
  sincronizarMaestros: (body = {}) => api.post('/presea/sincronizar-maestros', body),

  // Motor de resolución de conflictos (roadmap #12 — increment 2)
  resoluciones: (params = {}) => api.get('/presea/resoluciones', { params }),
  resolucion: (id) => api.get(`/presea/resoluciones/${id}`),
  detectarConflictos: () => api.post('/presea/resoluciones/detectar'),
  resolverConflicto: (id) => api.post(`/presea/resoluciones/${id}/resolver`),
  verificarConflicto: (id) => api.post(`/presea/resoluciones/${id}/verificar`),
}
